import {
    Package,
    Truck,
    XCircle,
    Clock3,
} from "lucide-react";

import "./DeliveryHistoryCard.css";

function DeliveryHistoryCard({
    partner,
    statistics,
}) {

    return (

        <div className="delivery-history-card">

            <div className="card-title">

                <h3>

                    Delivery Summary

                </h3>

            </div>

            <div className="history-grid">

                <div className="history-item">

                    <Truck size={22} />

                    <div>

                        <span>

                            Current Order

                        </span>

                        <strong>

                            {partner.work?.currentOrder
                                ? "Assigned"
                                : "No Active Order"}

                        </strong>

                    </div>

                </div>

                <div className="history-item">

                    <Package size={22} />

                    <div>

                        <span>

                            Total Deliveries

                        </span>

                        <strong>

                            {statistics?.totalDeliveries || 0}

                        </strong>

                    </div>

                </div>

                <div className="history-item">

                    <XCircle size={22} />

                    <div>

                        <span>

                            Cancelled Orders

                        </span>

                        <strong>

                            {statistics?.cancelled || 0}

                        </strong>

                    </div>

                </div>

                <div className="history-item">

                    <Clock3 size={22} />

                    <div>

                        <span>

                            Average Rating

                        </span>

                        <strong>

                            ⭐ {statistics?.rating || 0}

                        </strong>

                    </div>

                </div>

            </div>

            <div className="future-note">

                Individual delivery history, completed orders,
                customer feedback and delivery timeline will
                automatically appear here after the Order Module
                is integrated.

            </div>

        </div>

    );

}

export default DeliveryHistoryCard;